import React, { useState } from 'react';
import { 
  Paper, 
  TextField, 
  Button, 
  Typography, 
  Box,
  CircularProgress,
  useTheme
} from '@mui/material';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const JobDescriptionInput = ({ onSubmit, loading }) => {
  const [description, setDescription] = useState('');
  const theme = useTheme();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (description.trim()) {
      onSubmit({
        description: description.trim(),
        timestamp: new Date().toISOString()
      });
    }
  };

  return (
    <Paper 
      elevation={0} 
      sx={{ 
        p: 3,
        borderRadius: 3,
        border: `1px solid ${theme.palette.divider}`,
        background: theme.palette.blue['900'],
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: theme.shadows[4]
        }
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <WorkOutlineIcon sx={{color:theme.palette.white['100']}} />
        <Typography variant="h6" sx={{ fontWeight: 600,color:theme.palette.white['100'] }}>
          Job Details
        </Typography>
      </Box>

      <Typography variant="body2" color={theme.palette.white['100']}  sx={{ mb: 3 }}>
        Paste the job description you want to apply for
      </Typography>

      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          fullWidth
          multiline
          rows={8}
          placeholder="Enter the complete job description here..."
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          required
          variant="outlined"
          sx={{ 
            mb: 2,
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              backgroundColor: theme.palette.grey[50]
            }
          }}
        />
        <Button
          type="submit"
          variant="contained"
          disabled={loading || !description.trim()}
          fullWidth
          startIcon={loading ? <CheckCircleIcon /> : <CheckCircleIcon />}
          sx={{ 
            py: 1.5,
            borderRadius: 2,
            textTransform: 'none',
            fontSize: '1rem',
            color:theme.palette.white['100'],
            bgcolor:theme.palette.blue['700']
          }}
        >
          {loading ? 'Saving...' : 'Save Job Description'}
        </Button>
      </Box>
    </Paper>
  );
};

export default JobDescriptionInput;